import { confirmExit } from "./confirmExit";
import { Globals } from "../CoreApp/Globals";

export function DoSetOnBeforeUnload() {
  window.onbeforeunload = confirmExit;
  Globals._wsMgr.SetIgnoreExit(false);
}
